import type { ReactNode } from 'react';

import type { TabsItem } from './tabs.types.ts';

export const getTabTypeaheadLabel = (children: ReactNode): string => {
  if (typeof children === 'string' || typeof children === 'number') {
    return String(children);
  }

  return '';
};

export const resolveInitialTabValue = (
  items: TabsItem[],
  defaultValue?: TabsItem['value']
): string => {
  const preferred =
    defaultValue != null
      ? items.find(item => item.value === defaultValue && !item.tab.disabled)
      : undefined;
  const selected = preferred ?? items.find(item => !item.tab.disabled) ?? items[0];

  return selected != null ? String(selected.value) : '';
};

/** Keeps a valid current selection; otherwise falls back like initial mount. */
export const resolveTabValue = (
  items: TabsItem[],
  currentValue: string,
  defaultValue?: TabsItem['value']
): string => {
  if (currentValue !== '' && items.some(item => String(item.value) === currentValue)) {
    return currentValue;
  }

  return resolveInitialTabValue(items, defaultValue);
};
